<template>
  <validation-observer ref="form">
    <b-form-group>

      <label>Seleccione el medio difusión por el cual se enteró de la oferta académica *</label>
      <b-skeleton-wrapper :loading="mediosLoader">
        <template #loading>
          <b-skeleton
            type="button"
            width="100%"
            class="mb-75"
          />
        </template>
        <div class="mb-75">
          <v-select
            id="medio"
            v-model="selectMedio"
            placeholder="Seleccione"
            label="medio"
            :options="medios"
            :clearable="false"
            @input="(val) => medio = val"
          />
        </div>
      </b-skeleton-wrapper>
      <div v-if="medio && medio.id===7">
        <validation-provider
          #default="{ errors }"
          name="otro_medio"
          rules="required|min:3|max:150"
        >
          <b-form-textarea
            v-model="inputText"
            :state="errors.length > 0 ? false:null"
            placeholder="Describa brevemente cómo se enteró de la oferta académica"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </div>
    </b-form-group>
  </validation-observer>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup, BFormTextarea, BSkeletonWrapper, BSkeleton,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import { required } from '@validations'
import vSelect from 'vue-select'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BFormGroup,
    BFormTextarea,

    ValidationProvider,
    ValidationObserver,
    vSelect,
    BSkeletonWrapper,
    BSkeleton,
  },
  setup(_, { emit }) {
    const form = ref(null)
    const medio = ref(null)
    const inputText = ref('')
    const selectMedio = ref(null)

    const medios = ref([])
    const toast = useToast()
    const mediosLoader = ref(false)
    const loadMedios = () => {
      mediosLoader.value = true
      getData({ action: 40 }, 'wspublico')
        .then(response => {
          mediosLoader.value = false
          if (response.status === 200) {
            medios.value = response.data.data || []
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error cargando medios de información',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }, error => {
          mediosLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando medios de información',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    loadMedios()

    watch(inputText, value => {
      emit('on-value-change', value)
    })
    watch(selectMedio, value => {
      emit('on-select-change', value.id)
    })

    return {
      form,
      medio,
      inputText,
      selectMedio,
      medios,
      mediosLoader,
      required,
    }
  },
}
</script>
